export default () => ({
	audits: [],
	personWithAudit: [],
	oneAudit: null,
	loading: false,
});
